/* Customer Resources - opens image and video resources in the self-hosted
   GLightbox popup. PDFs and links use normal target="_blank" anchors and need
   no JS. Safe to have multiple sections on one page (single shared lightbox). */
(function () {
  'use strict';

  function initLightbox() {
    if (typeof window.GLightbox !== 'function') return false;
    // Refresh a single shared instance so newly added sections are included.
    if (window.__crGlightbox && typeof window.__crGlightbox.reload === 'function') {
      window.__crGlightbox.reload();
      return true;
    }
    window.__crGlightbox = window.GLightbox({
      selector: '.cr-glightbox',
      touchNavigation: true,
      loop: true,
      zoomable: true
    });
    return true;
  }

  class CustomerResources extends HTMLElement {
    connectedCallback() {
      // Only needed when at least one media resource opts into the lightbox.
      if (!this.querySelector('.cr-glightbox')) return;
      if (initLightbox()) return;
      // GLightbox script is deferred; retry briefly until it is ready.
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (initLightbox() || tries > 40) clearInterval(timer);
      }, 100);
    }
  }

  if (!customElements.get('customer-resources')) {
    customElements.define('customer-resources', CustomerResources);
  }
})();
